<script setup>
import { onMounted, reactive, ref } from "vue";

const rootRef = ref();
const originalRef = ref();
const parentRef = ref();
const sticked = ref(false);
const initialState = reactive({
    top: 0,
    left: 0,
    width: 0,
});
const props = defineProps({
    offsetTop: {
        type: Number,
        default: 0,
    },
    offsetTrigger: {
        type: Number,
        default: 0,
    },
});

function onScroll(e) {
    const scrollTop = e.target.scrollTop;
    if (
        scrollTop >
        parseInt(initialState.top) + parseInt(props.offsetTrigger)
    ) {
        rootRef.value.style.top = props.offsetTop + "px";
        rootRef.value.style.left = initialState.left + "px";
        rootRef.value.style.width = initialState.width + "px";
        rootRef.value.style.zIndex = 100;
        sticked.value = true;
    } else {
        sticked.value = false;
    }
}

onMounted(() => {
    parentRef.value = rootRef.value.closest("[data-sticky-element-parent]");
    parentRef.value.addEventListener("scroll", onScroll);

    initialState.top = originalRef.value.offsetTop;
    initialState.left = originalRef.value.offsetLeft;
    initialState.width = originalRef.value.offsetWidth;

    console.log(initialState);
});
</script>

<template>
    <Transition name="slide-down" v-show="sticked">
        <div ref="rootRef" class="sticky-element">
            <slot></slot>
        </div>
    </Transition>
    <div ref="originalRef">
        <slot></slot>
    </div>
</template>

<style scoped>
.sticky-element {
    animation: slide-down 0.3s ease-in-out;
    background: #fff;
    padding: 8px 20px;
    border-radius: 16px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    position: fixed;
}

.slide-down-enter-active,
.slide-down-leave-active {
    transition: all 0.3s ease-in-out;
}
.slide-down-enter-from,
.slide-down-leave-to {
    transform: translateY(-100%);
    opacity: 0;
}
.slide-down-enter-to,
.slide-down-leave-from {
    transform: translateY(0);
    opacity: 1;
}
</style>
